import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { provide } from 'vue';
import ReportRoomItem from '@/components/report/Item.vue';
import { Type } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'Type',
  props: {
  index: Number,
  type: Type,
},
  setup(__props) {

const props = __props;

provide('typeIndex', props.index);
provide('typeSlug', props.type!.slug);
provide('typeName', props.type!.name);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.type!.items, (item, $index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item._uuid
      }, [
        _createVNode(ReportRoomItem, {
          item: item,
          index: $index
        }, null, 8, ["item", "index"])
      ]))
    }), 128))
  ]))
}
}

})